// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"9de320d0","661":"067ea451","787":"8002e252"}[chunkId] + ".chunk.js";
};